import { useMutation } from 'react-query'

import { tfaService } from '@/modules/profile-settings/service/tfa-service.tsx'

export function useEnableTfa() {
  return useMutation('tfa-enable', tfaService.enableTfa)
}
